import { render, staticRenderFns } from "./UserRankList.vue?vue&type=template&id=0d16f26f&scoped=true"
import script from "./UserRankList.vue?vue&type=script&lang=js"
export * from "./UserRankList.vue?vue&type=script&lang=js"
import style0 from "./UserRankList.vue?vue&type=style&index=0&id=0d16f26f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d16f26f",
  null
  
)

export default component.exports